module.exports = __webpack_public_path__ + "static/media/pronunciation-lib-editor.9d40d3cf.svg";